import {
  translationFailedText,
  translationMemberOnlyText,
  translationQuotaText,
} from '../../lib/serviceStatusMessages.ts';

/** Extension i18n keys: web_translation_* (en defaults kept for tests). */
export const TRANSLATION_QUOTA_TEXT = 'Quota limit reached';
export const TRANSLATION_FAILED_TEXT = 'Failed';
export const TRANSLATION_MEMBER_ONLY_API_TEXT = 'Member only feature';

export type TranslationFailureKind = 'quota' | 'member_only' | 'failed';

export class TranslationError extends Error {
  readonly kind: TranslationFailureKind;

  constructor(kind: TranslationFailureKind, message?: string) {
    super(message ?? kind);
    this.name = 'TranslationError';
    this.kind = kind;
  }
}

export function messageForTranslationFailure(kind: TranslationFailureKind): string {
  switch (kind) {
    case 'quota':
      return translationQuotaText();
    case 'member_only':
      return translationMemberOnlyText();
    default:
      return translationFailedText();
  }
}

/** Mirrors extension applyV2TranslateFailure / catch → cue.translation. */
export function applyTranslationFailureToCues(
  cues: Array<{ translated?: boolean; translation?: string; loading?: boolean }>,
  kind: TranslationFailureKind = 'failed',
): void {
  const text = messageForTranslationFailure(kind);
  for (const cue of cues) {
    cue.translated = true;
    cue.translation = text;
    if (cue.loading) cue.loading = false;
  }
}

export function classifyTranslationError(err: unknown): TranslationFailureKind {
  if (err instanceof TranslationError) return err.kind;
  return 'failed';
}
